// src/modules/auth/ui/VerifyCodeForm.tsx

/** @jsx createElement */
import { createElement } from "../../../utils/jsx.ts";

import { CodeInput } from "./CodeInput.tsx";
import { verifyCode } from "../services/verifyCode.ts";
import { RequestAnotherCode } from "./RequestAnotherCode.tsx";

interface Params {
  email: string;
}

export const VerifyCodeForm = ({ email }: Params) => (
  <form class="login-form" onsubmit={async (event: SubmitEvent) => await verifyCode({ email, event })}>
    <div class="form-header">
      <h1>Logowanie</h1>
      <p>Wpisz kod wysłany na {email} aby się zalogować.</p>
    </div>
    <div class="form-body">
      {CodeInput({ name: "code" })}
      <button class="submit-button">Zaloguj</button>
      {RequestAnotherCode({ email })}
    </div>
  </form>
);
